import { useSyncExternalStore } from "react";

let organizationLocked = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getServerSnapshot() {
  return false;
}

export function setOrganizationLocked(locked: boolean) {
  if (organizationLocked === locked) return;
  organizationLocked = locked;
  listeners.forEach((listener) => listener());
}

export function getOrganizationLocked() {
  return organizationLocked;
}

export function useOrganizationLocked() {
  return useSyncExternalStore(
    subscribe,
    getOrganizationLocked,
    getServerSnapshot,
  );
}
